import React, { useState, useEffect } from 'react';
import { Ban, X } from 'lucide-react';
import ModalPortal from './ModalPortal';
import { TextField } from '@anyemp/ui-kit';

const ExcludeEventModal = ({ isOpen, onClose, onConfirm, isLoading = false }) => {
  const [reason, setReason] = useState('');

  useEffect(() => {
    if (isOpen) setReason('');
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <ModalPortal onClose={isLoading ? undefined : onClose} ariaLabel="Exclude event">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl max-w-md w-full mx-4">
        <div className="flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-700">
          <div className="flex items-center gap-3">
            <div className="flex-shrink-0 text-red-600 dark:text-red-400">
              <Ban className="h-6 w-6" />
            </div>
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
              Exclude event from statistics
            </h3>
          </div>
          <button
            onClick={onClose}
            disabled={isLoading}
            className="text-gray-400 hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-300 disabled:opacity-50"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="p-6 space-y-3">
          <p className="text-sm text-gray-600 dark:text-gray-400">
            This event will be excluded from statistics. You can restore it later.
          </p>
          <div>
            <TextField
              label="Reason (optional)"
              id="exclude-reason"
              multiline
              rows={3}
              fullWidth
              size="small"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              disabled={isLoading}
              placeholder="Why are you excluding this event?"
            />
          </div>
        </div>

        <div className="flex flex-col-reverse sm:flex-row sm:justify-end gap-3 p-6 border-t border-gray-200 dark:border-gray-700">
          <button
            type="button"
            onClick={onClose}
            disabled={isLoading}
            className="w-full sm:w-auto px-4 py-2 text-sm font-medium rounded-md border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={() => onConfirm(reason.trim())}
            disabled={isLoading}
            className="w-full sm:w-auto px-4 py-2 text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors disabled:opacity-50 inline-flex items-center justify-center gap-2"
          >
            {isLoading && (
              <div className="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full" />
            )}
            Exclude
          </button>
        </div>
      </div>
    </ModalPortal>
  );
};

export default ExcludeEventModal;
